import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from './svg-icon.component';
import { SvgIconDefinitionsComponent } from './svg-icon-definitions.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    SvgIconComponent,
    SvgIconDefinitionsComponent,
  ],
  exports: [
    SvgIconComponent,
    SvgIconDefinitionsComponent,
  ]
})
export class SvgIconModule {}
